import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingScreen from "./LandingScreen";
import HomeScreen from "./HomeScreen";
import PassphraseScreen from "./PassphraseScreen";
import StateGameScreen from "./StateGameScreen";
import LeadersGameScreen from "./LeadersGameScreen";
import HighScoreScreen from "./HighScoreScreen";
import { AppContext } from "./context/AppContext";

export default function App() {
  const [player, setPlayer] = useState("");
  const [userId, setUserId] = useState("");
  const [credits, setCredits] = useState(0);
  const [isGuest, setIsGuest] = useState(false);
  const [guestPlays, setGuestPlays] = useState({ presidents: 0, states: 0, leaders: 0 });
  const [wins, setWins] = useState(0);
  const [losses, setLosses] = useState(0);

  const logOut = () => {
    setPlayer("");
    setUserId("");
    setCredits(0);
    setIsGuest(false);
    setGuestPlays({ presidents: 0, states: 0, leaders: 0 });
    setWins(0);
    setLosses(0);
  };

  return (
    <AppContext.Provider value={{
      player, setPlayer,
      userId, setUserId,
      credits, setCredits,
      isGuest, setIsGuest,
      guestPlays, setGuestPlays,
      wins, setWins,
      losses, setLosses,
      logOut,
    }}>
      <Router>
        <Routes>
          <Route path="/" element={<LandingScreen />} />
          <Route path="/game" element={<HomeScreen />} />
          <Route path="/login" element={<PassphraseScreen />} />
          <Route path="/state-game" element={<StateGameScreen />} />
          <Route path="/leaders-game" element={<LeadersGameScreen />} />
          <Route path="/highscores" element={<HighScoreScreen />} />
        </Routes>
      </Router>
    </AppContext.Provider>
  );
}
